// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"e772a2c2","453":"54985702"}[chunkId] + ".chunk.js";
};